import cn from "classnames";
import React from "react";

const ToggleInitialPlanValues = (props) => {
    const { value, filterData } = props;
    return (
        <div
            data-test-id="show-initial-plan-values"
            className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer"
            onClick={() => filterData({ name: "showInitialPlanValues", value: !value })}
        >
            <i className={cn("checkbox d-inline-block mr-1", { "checkbox--checked": value })} />
            Отображать изначальный плановый пробег
        </div>
    );
};

export default ToggleInitialPlanValues;
